import { useSelector } from "react-redux";

import { selectAuth } from "@redux";
import { ComponentSpinWheel } from "src/Components/SpinWheel";


export const PageSpinWheel = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentSpinWheel
            memberTier={memberTier} avatar={""} fullName={""} />
    );
};
